<template>
    <div class="direct-input">
        <div class="direct-input__title">Vui lòng nhập số vào ô bên dưới</div>
        <div class="direct-input__content">
            <div class="direct-input__content--left">
                <InputNumberDash
                    :maxNumber="maxNumber"
                    :lengthNumber="lengthNumber"
                    :inputSelectedValue="getSelectedValue()"
                    @change="onChange"
                />
            </div>
            <div class="direct-input__content--right" v-if="history !== null">
                <BetNumber
                    :maxNumber="maxNumber"
                    :lengthNumber="lengthNumber"
                    :inputValue="history"
                    :inputSelectedValue="getSelectedValue()"
                    :modalId="modalId"
                    :id="'bet-number__' + gameInfo.id"
                    @onShow="showHistory"
                />
            </div>
        </div>
        <div class="direct-input__description" v-html="generateRule"></div>
    </div>
</template>

<script>
import InputNumberDash from '@/components/common/InputNumberDash/InputNumberDash';
import BetNumber from '@/components/common/BetNumber/BetNumber';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
    name: 'DirectInput',
    components: {
        InputNumberDash,
        BetNumber,
    },
    data() {
        return {
            lengthNumber: 2,
            maxNumber: 4,
            modalId: '',
            history: null,
        };
    },
    props: {
        gameInfo: Object,
        rate: Number,
    },
    watch: {
        '$store.state.userModule.history': function() {
            this.updateHistory();
        },
    },
    computed: {
        ...mapGetters({
            betData: 'betModule/betData',
            betHistory: 'userModule/history',
        }),
        generateRule() {
            const generatedRule = this.gameInfo.guide.replace(
                new RegExp('{{ODDS}}', 'g'),
                () => `<span class="highlight">${this.rate}</span>`,
            );
            return `<span>${generatedRule}</span>`;
        },
    },
    methods: {
        onChange(arrayValue) {
            this.$store.dispatch('betModule/setBetDataByKey', {
                key: 'numbers',
                value: arrayValue,
            });
        },
        getSelectedValue() {
            return this.betData.numbers;
        },
        updateHistory: async function() {
            if (this.betHistory) {
                if (this.history === null) this.history = [];
                const filteredNumberLists = this.betHistory
                    .filter(bet => bet.category.code === this.gameInfo.code)
                    .sort(function(a, b) {
                        return (
                            Date.parse(a.create_at) - Date.parse(b.create_at)
                        );
                    })
                    .map(bet => bet.numbers);
                filteredNumberLists.forEach(numberList => {
                    const numberArr = numberList.split('-');
                    numberArr.forEach(number => {
                        const numberValue = parseFloat(number);
                        if (!this.history.includes(numberValue)) {
                            this.history.push(numberValue);
                        }
                    });
                });
            }
        },
        showHistory() {
            this.updateHistory();
        },
        loadData() {
            this.history = null;
            this.updateHistory();
            this.lengthNumber = (this.gameInfo.max - 1).toString().length;
            this.maxNumber =
                this.gameInfo.max_number === 0 ? 10 : this.gameInfo.max_number;
            this.modalId = this.gameInfo.code;
        },
    },
    beforeUpdate() {
        this.loadData();
    },
    created() {
        this.loadData();
    },
});
</script>

<style scoped lang="scss">
@import './DirectInput';
</style>
